import type React from "react"
import { forwardRef } from "react"
import { cn } from "@/lib/utils"

interface GlassCardProps extends React.HTMLAttributes<HTMLDivElement> {}

export const GlassCard = forwardRef<HTMLDivElement, GlassCardProps>(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        "relative rounded-2xl border border-primary/10 bg-background/50 backdrop-blur-sm shadow-sm",
        className,
      )}
      {...props}
    />
  )
})

GlassCard.displayName = "GlassCard"
